module.exports = __webpack_public_path__ + "static/media/slxx.0b3783d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/slxx.png
// module id = 682
// module chunks = 0 1